(function () {
  if (window.__customAutoscrollScriptInitialized) return;
  window.__customAutoscrollScriptInitialized = true;

  const heroStripStates = new WeakMap();

  const addMediaQueryListener = (query, handler) => {
    if (query.addEventListener) {
      query.addEventListener('change', handler);
    } else if (query.addListener) {
      query.addListener(handler);
    }
  };

  const removeMediaQueryListener = (query, handler) => {
    if (query.removeEventListener) {
      query.removeEventListener('change', handler);
    } else if (query.removeListener) {
      query.removeListener(handler);
    }
  };

  const initStepSlider = (slider) => {
    if (slider.dataset.autoscrollInitialized === 'true') return;

    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const intervalTime = parseInt(slider.dataset.autoplayInterval, 10) || 3000;

    if (!autoplayEnabled) return;

    const track = slider.querySelector('ul.slider');
    const nextButton = slider.querySelector('.slider-button--next');

    if (!track || !nextButton) return;

    slider.dataset.autoscrollInitialized = 'true';

    let autoplayInterval;

    const autoplayStep = () => {
      if (nextButton.hasAttribute('disabled')) {
        track.scrollTo({
          left: 0,
          behavior: 'smooth',
        });
      } else {
        nextButton.click();
      }
    };

    const startAutoplay = () => {
      stopAutoplay();
      autoplayInterval = setInterval(autoplayStep, intervalTime);
    };

    const stopAutoplay = () => {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    };

    startAutoplay();

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin', stopAutoplay);
    slider.addEventListener('focusout', startAutoplay);

    document.addEventListener('visibilitychange', () => {
      document.hidden ? stopAutoplay() : startAutoplay();
    });
  };

  const initHeroIconStrip = (autoscroll) => {
    if (heroStripStates.has(autoscroll)) return;

    const autoplayEnabled = autoscroll.dataset.autoscrollEnabled === 'true';
    const intervalTime = parseInt(autoscroll.dataset.autoplayInterval, 10) || 3000;
    const slideCount = parseInt(autoscroll.dataset.slideCount, 10) || 0;
    const track = autoscroll.querySelector('.hero-icon-strip__autoscroll-track');

    if (!autoplayEnabled || !track || slideCount < 2) return;

    const totalSlides = track.children.length;
    const loopStartIndex = slideCount;
    const loopEndIndex = totalSlides - 1;
    const readyClass = 'hero-icon-strip__autoscroll--ready';

    const mobileQuery = window.matchMedia('(max-width: 989px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const state = {
      intervalId: null,
      handleMotionChange: null,
      handleViewportChange: null,
      handleVisibilityChange: null,
      hasInitializedPosition: false,
      mobileQuery,
      reducedMotionQuery,
      stop: () => {},
    };

    const getSlideWidth = () => track.clientWidth;
    const getCurrentIndex = () => {
      const slideWidth = getSlideWidth();
      if (!slideWidth) return 0;
      return Math.round(track.scrollLeft / slideWidth);
    };

    const scrollToIndex = (index, behavior) => {
      const slideWidth = getSlideWidth();
      if (!slideWidth) return;

      track.scrollTo({
        left: index * slideWidth,
        behavior,
      });
    };

    const stop = () => {
      if (state.intervalId) {
        clearInterval(state.intervalId);
        state.intervalId = null;
      }
    };

    const start = () => {
      stop();

      if (!mobileQuery.matches || document.hidden || reducedMotionQuery.matches) return;

      if (!state.hasInitializedPosition) {
        autoscroll.classList.remove(readyClass);
        scrollToIndex(loopStartIndex, 'auto');
        state.hasInitializedPosition = true;

        requestAnimationFrame(() => {
          autoscroll.classList.add(readyClass);
        });
      }

      state.intervalId = setInterval(() => {
        const currentIndex = getCurrentIndex();

        if (currentIndex >= loopEndIndex) {
          track.scrollLeft = loopStartIndex * getSlideWidth();
          return;
        }

        scrollToIndex(currentIndex + 1, 'smooth');
      }, intervalTime);
    };

    const handleVisibilityChange = () => {
      document.hidden ? stop() : start();
    };

    const handleViewportChange = () => {
      mobileQuery.matches ? start() : stop();
    };

    const handleMotionChange = () => {
      reducedMotionQuery.matches ? stop() : start();
    };

    state.stop = stop;
    state.handleVisibilityChange = handleVisibilityChange;
    state.handleViewportChange = handleViewportChange;
    state.handleMotionChange = handleMotionChange;

    heroStripStates.set(autoscroll, state);
    autoscroll.dataset.autoscrollInitialized = 'true';

    addMediaQueryListener(mobileQuery, handleViewportChange);
    addMediaQueryListener(reducedMotionQuery, handleMotionChange);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    start();
  };

  const init = (root = document) => {
    root.querySelectorAll('.custom-multicolumn-slider, .custom-logo-carousel-slider').forEach(initStepSlider);
    root.querySelectorAll('.custom-hero-icon-strip-autoscroll').forEach(initHeroIconStrip);
  };

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target || document);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target
      .querySelectorAll('.custom-hero-icon-strip-autoscroll')
      .forEach((autoscroll) => {
        const state = heroStripStates.get(autoscroll);
        if (!state) return;

        state.stop();
        removeMediaQueryListener(state.mobileQuery, state.handleViewportChange);
        removeMediaQueryListener(state.reducedMotionQuery, state.handleMotionChange);
        document.removeEventListener('visibilitychange', state.handleVisibilityChange);
        heroStripStates.delete(autoscroll);
        delete autoscroll.dataset.autoscrollInitialized;
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        init();
      },
      { once: true }
    );
  } else {
    init();
  }
})();
